import React, { createElement, CSSProperties, FC } from 'react';
import { StyledH1, StyledH2, StyledH3, StyledH4, StyledH5, StyledH6, StyledH7 } from './styles';

export interface Props {
  level: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
  color?: string;
  style?: CSSProperties;
  children: React.ReactNode | React.ReactNode[];
}

const Heading: FC<Props> = ({
  children,
  level,
  top = 0,
  right = 0,
  bottom = 0,
  left = 0,
  color,
  style,
}) => {
  const elements = {
    1: StyledH1,
    2: StyledH2,
    3: StyledH3,
    4: StyledH4,
    5: StyledH5,
    6: StyledH6,
    7: StyledH7,
  };

  return createElement(elements[level], { top, right, bottom, left, color, style }, children);
};

export default React.memo(Heading);
